import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DefaultLocalCouponService } from '@asm/features/sync/services/coupon/default-local-coupon.service';

/**
 * Handler offline para operações de cupom — atua como controller HTTP.
 * Extrai os dados do request e delega ao DefaultLocalCouponService.
 *
 * Cobre:
 * - GET  /cart/coupon/available          → listar cupons disponíveis
 * - POST /cart/{code}/coupon             → aplicar cupom ao carrinho
 * - DELETE /cart/{code}/coupon           → remover cupom do carrinho
 *
 * IMPORTANTE: deve ser registrado ANTES de CartOfflineHandler no OfflineInterceptor
 * para que `/cart/coupon/available` não seja capturado pelo padrão `/cart/:code`.
 */
@Injectable({ providedIn: 'root' })
export class PromotionOfflineHandler {
  private readonly couponService = inject(DefaultLocalCouponService);

  canHandle(req: HttpRequest<unknown>): boolean {
    const { url, method } = req;
    return (
      (method === 'GET' && url.includes('/cart/coupon/available')) ||
      (method === 'POST' && /\/cart\/[^/]+\/coupon$/.test(url)) ||
      (method === 'DELETE' && /\/cart\/[^/]+\/coupon$/.test(url))
    );
  }

  async handle(req: HttpRequest<unknown>): Promise<HttpResponse<unknown>> {
    const { url, method } = req;
    const b2bUnitId = req.headers.get('x-b2bunit-id') ?? '';

    if (method === 'GET' && url.includes('/cart/coupon/available')) {
      return new HttpResponse({ status: 200, body: await this.couponService.getAvailableCoupons() });
    }

    if (method === 'POST' && /\/cart\/[^/]+\/coupon$/.test(url)) {
      const couponCode = (req.body as any)?.couponCode ?? '';
      return new HttpResponse({ status: 200, body: await this.couponService.applyCoupon(url, couponCode, b2bUnitId) });
    }

    if (method === 'DELETE' && /\/cart\/[^/]+\/coupon$/.test(url)) {
      return new HttpResponse({ status: 200, body: await this.couponService.removeCoupon(url, b2bUnitId) });
    }

    throw new Error(`[PromotionOfflineHandler] Rota não mapeada: ${method} ${url}`);
  }
}
